import { Availability } from "./booking-module/availability.model";
import { Step1 } from "./booking-module/cards";
import { getJsonDataFor, Variables, initializeFilters } from "./booking-module/common";



// First thing is to download discount codes, max number of each room, and duration discounts
Variables.$.when(
    getJsonDataFor("chalets-availabilities"),
)
    .then((avb: Availability[]) => {

        const $availabilitiesDiv = Variables.$(`#${Variables.availabilitiesDivId}`);
        avb.forEach(element => {
            // converting string to date object
            element.arrivalDate = new Date(element.arrivalDate);
            element.departureDate = new Date(element.departureDate);
        });

        const fromDate = new Date($availabilitiesDiv.data('from-date'));
        const toDate = new Date($availabilitiesDiv.data('to-date'));

        avb = avb.filter(element => element.arrivalDate >= fromDate && element.departureDate <= toDate);

        Step1.instance.makeCards(avb);

        // Show filter controls and initialize after cards are rendered
        Variables.$('#pricesFilterContainer').show();
        initializeFilters();

        Variables.$(`#${Variables.loadingDivId}`).hide();
        $availabilitiesDiv.show();
    })
    .catch(() => {
        Variables.$(`#${Variables.loadingDivId}`).hide();
    });